<template>
  <div
      class="mx-auto h-[438px] w-[312px] bg-[url(/resources/images/cmspage_ad_bg.png)] bg-cover"
  >
    <div class="flex h-full flex-col px-6 pb-8 pt-3 text-center text-white">
      <div class="mb-8 text-xl font-semibold">Need to recertify?</div>
      <div class="text-base leading-7">
        The easiest way to get your CE hours, 100% online.
        <ul class="list-inside list-disc pb-0 pt-2 text-left">
          <li>Dozens of courses and topics</li>
          <li>State-specific requirements</li>
          <li>We report to CAPCE in real time</li>
        </ul>
      </div>
      <div class="flex flex-grow items-center justify-center pb-2">
        <img :src="getImageUrl('capce_accredited_badge.png')" alt="CAPCE Accredited"/>
      </div>
      <div>
        <a class="btn btn-primary block text-center mt-2" href="https://emt-ce.com">Go to EMT-CE.com</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "emtce-promo-ad",
};
</script>
